module.exports = __webpack_public_path__ + "static/img/WorkW1.27eb53ea.png";